import { CheckinAllSettings } from '../app/types'
import {
  createApi,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react'
import { createLogger } from '../app/logger'

// eslint-disable-next-line no-unused-vars
const logger = createLogger({
  prefix: 'cdnApi'
})

const cdnApi = createApi({
  reducerPath: 'cdnApi',
  baseQuery: fetchBaseQuery({}),
  endpoints: build => ({
    getCheckinSettings: build.query<CheckinAllSettings, number | undefined>({
      query: (eventId) => ({
        url: `${process.env.REACT_APP_BAZU_STATIC_URL}/pickup/event/${eventId}/settings.json?t=${Date.now()}`,
        headers: { 'Cache-Control': 'no-cache' },
      })
    })
  })
})

export const {
  useGetCheckinSettingsQuery,
} = cdnApi

export default cdnApi
